<template>
  <div class="t hidden-lg hidden-md hidden-sm">
    <div class="menu ">
      <div class="m_item">
        <router-link :to="{ name: 'index' }">
          <div class="m_icon">
            <img src="../../static/index-1.png" />
          </div>
          <div class="m_text">首页</div></router-link
        >
      </div>
      <div class="m_item">
        <router-link :to="{ name: 'circle_index' }">
          <div class="m_icon"><img src="../../static/circle-1.png" /></div>
          <div class="m_text">圈子</div></router-link
        >
      </div>
      <div class="m_item">
        <router-link :to="{ name: 'centerindex' }">
          <div class="m_icon"><img src="../../static/center-1.png" /></div>
          <div class="m_text">我的</div></router-link
        >
      </div>
    </div>
    <div class="menu_bg"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  methods: {}
};
</script>

<style lang="less" scoped>
.t {
  width: 100%;
}
.menu_bg {
  height: 1.2rem;
}
.menu {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 1.2rem;
  background: #fff;
  z-index: 2;
  display: flex;
  justify-content: space-around;

  .m_item {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    .m_icon {
      img {
        width: 0.5rem;
        height: 0.5rem;
      }
    }
    .m_text {
      font-size: 0.26rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/foot.vue